<!--  -->
<template>
<!-- 3.视频课程案例 -->
  <div class="wow fadeInUp mobile_wrap_video_case"> 
    <el-row >
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block" >
        <div class="wrap_btn">
          <div class="btn_block" :class="selectedIndex === index?'active':''" v-for="(item,index) in btnlist" :key="index" @click="picsFn(index)">{{item}}</div>
        </div>
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
    <el-row>
      <el-col :span="1" class="header_block"></el-col>
      <el-col :span="22" class="header_block" >
        <div class="ProgressBoxTool" v-if="progressList && progressList.length">
          <div class="prevBtn" ref="prevBtn"><img :src="require('@/assets/imgs/leftarror.png')"  class="server_img"  @click="fnPrev()" /></div>
          <div class="nextBtn" ref="nextBtn"><img :src="require('@/assets/imgs/rightarror.png')" class="server_img"  @click="fnNext()" /></div>
          <div class="processBox">
            <div class="fixedBox" :ref="`fixedBox`">
              <div
                class="centerScroll"
                :style="
              `width:${signleWidth *
                progressList.length}px;transform:translate(${scrollResultWidth}px,0);transition:1s;`
            "
              >
                <div
                  ref="aaa"
                  class="signleTab"
                  v-for="(itemP, indexP) in progressList"
                  :key="indexP + 'progress'"
                  @click="selectPics(itemP)"
                >
                  <!-- <div class="leftIcon"> -->
                  <img class="pregressIcon" ref="imgsIcon" :src="itemP.url" alt />
                  <div class="wrap_mask_title">
                    <div class="mask_title">{{itemP.text}}</div>
                  </div>
                  <!-- </div> -->
                  <!-- 最后一个不展示箭头 -->
                  <!-- <img
                v-if="progressList.length > indexP + 1"
                :src="iconArrow"
                alt=""
                class="arrowSquare"
                  />-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="1" class="header_block"></el-col>
    </el-row>
    <!-- <el-row >
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block" >
       <div class="posts-nav-wrap">
        	        <ul class="posts-nav">          	
                        <li class="previous" @click="fnPrev()"><a  class="previous">←</a></li>
                        <li class="next" @click="fnNext()"><a  class="next">←</a></li>
                    </ul>
            </div> 
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row> -->
  </div>
</template>
 
<script>
// import arrowL from '@/assets/images/emergency/arrowL.png';
// import arrowR from '@/assets/images/emergency/arrowR.png';
// import icon from '@/assets/images/emergency/icon.png';
// import iconArrow from '@/assets/images/emergency/iconArrow.png';
import arrowL from "@/assets/imgs/pics01.png";
import arrowR from "@/assets/imgs/pics01.png";
import icon from "@/assets/imgs/pics01.png";
import iconArrow from "@/assets/imgs/pics01.png";
export default {
  components: {},
  data() {
    return {
      selectedIndex:0,
      btnlist: ["研学实景课", "抠像课", "动画课"],
      progressList: [
        { type: "1", url: require("@/assets/imgs/pagesix/video501.jpg"),text:'科学小课堂——清华博士带你走进迷你实验室',videoUrl:require('@/assets/imgs/pagesix/video501.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video502.jpg"),text:'梁博士带你上天——航空航天知识科普',videoUrl:require('@/assets/imgs/pagesix/video502.mp4') },
        { type: "1", url: require("@/assets/imgs/pagesix/video503.jpg"),text:'森林里的诗词课',videoUrl:require('@/assets/imgs/pagesix/video503.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video504.jpg"),text:'生肖捏捏捏——郎佳子彧的手工课',videoUrl:require('@/assets/imgs/pagesix/video504.mp4') }
      ],
      progressListArr: [
        [ { type: "1", url: require("@/assets/imgs/pagesix/video501.jpg"),text:'科学小课堂——清华博士带你走进迷你实验室',videoUrl:require('@/assets/imgs/pagesix/video501.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video502.jpg"),text:'梁博士带你上天——航空航天知识科普',videoUrl:require('@/assets/imgs/pagesix/video502.mp4') },
        { type: "1", url: require("@/assets/imgs/pagesix/video503.jpg"),text:'森林里的诗词课',videoUrl:require('@/assets/imgs/pagesix/video503.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video504.jpg"),text:'生肖捏捏捏——郎佳子彧的手工课',videoUrl:require('@/assets/imgs/pagesix/video504.mp4') }],
        [{ type: "1", url: require("@/assets/imgs/pagesix/video601.jpg"),text:'读国外经典名篇 做英语阅读小达人',videoUrl:require('@/assets/imgs/pagesix/video601.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video602.jpg"),text:'儿童时间管理课——让孩子学习更高效',videoUrl:require('@/assets/imgs/pagesix/video602.mp4') },
        { type: "1", url: require("@/assets/imgs/pagesix/video603.jpg"),text:'跟陈更姐姐一起 品读经典诗句 掌握写作技巧',videoUrl:require('@/assets/imgs/pagesix/video603.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video604.jpg"),text:'红楼梦趣味跟读——跟大师学写作',videoUrl:require('@/assets/imgs/pagesix/video604.mp4') },
        { type: "1", url: require("@/assets/imgs/pagesix/video605.jpg"),text:'郦波说——从汉字到写作',videoUrl:require('@/assets/imgs/pagesix/video605.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video606.jpg"),text:'魔方冠军亲授——零基础魔方课',videoUrl:require('@/assets/imgs/pagesix/video606.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video607.jpg"),text:'清华心理专家的育儿课',videoUrl:require('@/assets/imgs/pagesix/video607.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video608.jpg"),text:'趣说文物巧学成语——朋朋哥哥带你逛博物馆',videoUrl:require('@/assets/imgs/pagesix/video608.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video609.jpg"),text:'西游记趣味跟读——让孩子学会讲故事',videoUrl:require('@/assets/imgs/pagesix/video609.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video610.jpg"),text:'学霸外教带你学——4节课搞定常见口语',videoUrl:require('@/assets/imgs/pagesix/video610.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video611.jpg"),text:'学好英语表达 与世界轻松对话',videoUrl:require('@/assets/imgs/pagesix/video611.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video612.jpg"),text:'幼儿趣味数独课',videoUrl:require('@/assets/imgs/pagesix/video612.mp4') }],
        [{ type: "1", url: require("@/assets/imgs/pagesix/video701.jpg"),text:'九大诗人趣味故事',videoUrl:require('@/assets/imgs/pagesix/video701.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video702.jpg"),text:'零基础掌握记忆法',videoUrl:require('@/assets/imgs/pagesix/video702.mp4') },
        { type: "1", url: require("@/assets/imgs/pagesix/video703.jpg"),text:'数学超有趣——北大硕士的数学课',videoUrl:require('@/assets/imgs/pagesix/video703.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video704.jpg"),text:'唐朝奇遇记',videoUrl:require('@/assets/imgs/pagesix/video704.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video705.jpg"),text:'有趣的数学家',videoUrl:require('@/assets/imgs/pagesix/video705.mp4') },
        { type: "2", url: require("@/assets/imgs/pagesix/video706.jpg"),text:'有趣的图形——数形结合',videoUrl:require('@/assets/imgs/pagesix/video706.mp4') },
        ],
      ],
      arrowL,
      arrowR,
      icon,
      iconArrow,
      currentProgressId: "",
      scrollResultWidth: 0, //transform滚动的距离
      signleWidth: 215, //单个流程的宽度
      activeName: 0,
      currentClickNumber: 0,
      noScrollRight: true,
      initHeight:0,
    };
  },
  
  mounted() {
    this.$nextTick(() => {
      // let initHeight = this.$refs.imgsIcon[0].clientHeight
      // console.log(initHeight,'initHeight')
      // // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
    setTimeout(() => {
      this.signleWidth =
        ((document.documentElement.clientWidth / 24) * 22 - 10) / 2;
      for (let i = 0; i < this.$refs.aaa.length; i++) {
        this.$refs.aaa[i].style.width = this.signleWidth + "px";
      }
      // setTimeout(() => {
      // this.initHeight = this.$refs.imgsIcon[0].clientHeight
      // this.$refs.prevBtn.style.top = (this.initHeight - 55)/2 + 'px'
      // this.$refs.nextBtn.style.top = (this.initHeight - 55)/2 + 'px'
      // console.log(this.$refs.prevBtn,'initHeight')
      // }, 1000);
    }, 1000);
  },
  created() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initgoRightArrow();
      });
    });
  },
  methods: {
    selectPics(item){
      this.$emit('selectPics',item)
    },
    //初始化判断是否可以向右滚动
    initgoRightArrow() {
      const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressList.length) {
        this.noScrollRight = false;
        return;
      }
    },
    //点击上一个
    fnPrev() {
      //如果右点击的次数大于0，才可以左滚
      if (this.currentClickNumber > 0) {
        this.currentClickNumber -= 1;
        this.noScrollRight = true;
        this.fnScrollWidth("reduce");
      } else {
        return false;
      }
    },
    picsFn(index){

      setTimeout(() => {
      this.signleWidth =
        ((document.documentElement.clientWidth / 24) * 22 - 10) / 2;
      for (let i = 0; i < this.$refs.aaa.length; i++) {
        this.$refs.aaa[i].style.width = this.signleWidth + "px";
      }
    }, 1000);


        this.selectedIndex = index
        console.log(111)
        this.progressList = this.progressListArr[index]
        // this.scrollResultWidth = 0

        this.currentProgressId=""
      this.scrollResultWidth=0 //transform滚动的距离
    //   this.signleWidth=215 //单个流程的宽度
      this.activeName=0
      this.currentClickNumber=0
      this.noScrollRight=true
    },
    //点击下一个
    fnNext() {
      const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.progressList.length) {
        return;
      }
      //说明放不下有滚动条
      if (this.progressList.length > canNumber) {
        this.currentClickNumber += 1;
        if (this.currentClickNumber + canNumber >= this.progressList.length) {
          this.noScrollRight = false;
        }
        this.fnScrollWidth("add");
      }
    },
    //translate的宽度
    fnScrollWidth(type) {
      let result = 0;
      if (type === "reduce") {
        result = this.signleWidth + 10;
      } else if (type === "add") {
        result = -this.signleWidth - 10;
      } else {
        result = 0;
      }
      this.scrollResultWidth += result;
    }
  }
};
</script>
<style lang="less" scoped>
.mobile_wrap_video_case{
  .ProgressBoxTool{
    position: relative;
  }
  .prevBtn{
    width: 40px;
    height: 40px;
    // position: absolute;
    // left: -20px;
    // top: 97.5px;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(-16px, calc(-50% - 25px));

    .server_img{
      width: 40px;
      height: 40px;
    }
  }
  .nextBtn{
    width: 40px;
    height: 40px;
    // position: absolute;
    // right: -20px;
    // top: 97.5px;
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translate(16px, calc(-50% - 25px));
    z-index: 1;
    .server_img{
      width: 40px;
      height: 40px;
    }
  }


   .posts-nav-wrap{text-align:center;width:100%;height:32px;display:inline-block;clear:both;}

.posts-nav li{margin:0 13px 0 0;display:inline-block;box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .05);}

.posts-nav li a{text-indent:-9999em;text-align:left;-moz-border-radius:5px;-webkit-border-radius:5px;border-radius:5px;display:inline-block;-moz-transition:all .20s ease-in-out;-webkit-transition:all .20s ease-in-out;transition:all .20s ease-in-out;}

.posts-nav .next a{background:#a4a4a4 url(../assets/imgs/ico-pagination-arrow-next.png) no-repeat center;width:144px;height:32px;line-height:32px;outline: none;}
.posts-nav .next a:hover{cursor: pointer; text-decoration:none;background:#e91d62 url(../assets/imgs/ico-pagination-arrow-next.png) no-repeat 110px center;}

.posts-nav .previous a{width:64px;height:32px;line-height:32px;background-color:#a4a4a4;background-image:url(../assets/imgs/ico-pagination-arrow-previous.png);background-position:center;background-repeat:no-repeat;outline: none;}
.posts-nav .previous a:hover{cursor: pointer;text-decoration:none;background:#e91d62 url(../assets/imgs/ico-pagination-arrow-previous.png) no-repeat 12px center;}

.wrap_btn {
  display: flex;
  height: 70px;
  justify-content: center;
  .btn_block {
    width: 90px;
    height: 30px;
    line-height: 30px;
    border-radius: 20px;
    text-align: center;
    font-size: 14px;
    margin-right: 12px;
    color: #fff;
    border: 1px solid #a4a4a4;
    color: #a4a4a4;
    // background: #e91d62;
  }
  .btn_block:hover{
    cursor: pointer;
    border: 1px solid #e91d62 ;
    color: #e91d62;
  }
  .active{
    color: #e91d62;
    border:1px solid #e91d62;
  }
}
.header_block {
  min-height: 10px;
}
//中间的时间发展部分
.processBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .arrow {
    width: 60px;
    cursor: pointer;
  }
  .arrowOpacity {
    cursor: default;
    opacity: 0.4;
  }
  .fixedBox {
    flex: 1;
    overflow: hidden;
  }
  .centerScroll {
    // flex: 1;
    box-sizing: border-box;
    // padding: 20px 0;
    white-space: nowrap;
    

    // overflow-x: auto;
    .signleTab {
      //   width: 215px;
      position: relative;
      display: inline-block;
      margin-right: 10px;
      // width: calc((100% / 24 * 20 - 30px) / 4);
      //   .leftIcon {
      //     width: 150px;
      //     text-align: center;
      //     cursor: pointer;
      //     & > .pregressIcon {
      //       width: 60px;
      //       height: 60px;
      //     }
      //   }
      .pregressIcon {
        width: 100%;
        // width: calc((100% / 24 * 20 - 30) / 4);
        
      }
      .wrap_mask_title{
        width: 100%;
        height: 60px;
        display: flex;
      }
      .mask_title{
        box-sizing: border-box;
        padding-top: 15px;
        width: 100%;
        height: 60px;
        font-size: 14px;
        color: #666;
        width: 100%;
        z-index: 3;
        text-align: center;
        white-space: break-spaces;
        // height: 60px;
        line-height: 20px;
        /* border-radius: 0px 0px 5px 5px; */
      }
      & > .arrowSquare {
        position: absolute;
        top: 25px;
        right: 0;
      }
    }
  }
}
}
</style>
 